const applyConfig = (config) => {
  config.settings.isMultilingual = true;
  config.settings.supportedLanguages = ['en', 'de'];
  config.settings.defaultLanguage = 'de';

  config.settings.showTags = false;
  config.settings.navDepth = 3;
  config.settings.openExternalLinkInNewTab = true;
  config.settings.hashLinkSmoothScroll = true;
  config.settings.blockSettingsTabFieldsetsInitialStateOpen = false;
  config.settings.siteTitleFormat.includeSiteTitle = true;
  config.settings.siteTitleFormat.titleAndSiteTitleSeparator = '|';
  config.blocks.blocksConfig.slider.enableAutoPlay = true;
  config.settings.slate.useLinkedHeadings = false;
  config.settings.image_crop_aspect_ratios = [
    {
      label: '16:9',
      ratio: 16 / 9,
    },
    {
      label: '4:3',
      ratio: 4 / 3,
    },
    {
      label: '1:1',
      ratio: 1,
    },
  ];

  return config;
};

export default applyConfig;
